import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Accordion from "react-bootstrap/Accordion";
import { Context } from ".././utils/context";
library.add(fas);

function Header() {
  const { getData, IMG_URL } = useContext(Context);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [scroll, setScroll] = useState(false);

  const [data, setData] = useState([]);
  const getDataAll = async () => {
    try {
      const response = await getData(`/without-login/category/all-category`);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);
  useEffect(() => {
    getDataAll();
  }, []);

  const location = useLocation();
  const [activeItem, setActiveItem] = useState(() => {
    return localStorage.getItem("activeItem") || "home";
  });

  useEffect(() => {
    const path = location.pathname.substr(1);
    updateActiveItem(path || "home");
  }, [location]);

  const updateActiveItem = (newActiveItem) => {
    localStorage.setItem("activeItem", newActiveItem);
    setActiveItem(newActiveItem);
  };

  return (
    <>
      <section className={`header-main ${scroll ? "scrolled" : ""}`}>
        <div className="container-fluid p-0">
          <Navbar expand="lg" className="">
            <Container className="p-0">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse id="basic-navbar-nav" className="menus-main">
                <Navbar.Brand as={Link} to="/">
                  <img
                    className="headlogo"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/Logo.png"
                    }
                    alt="Logo"
                  />
                </Navbar.Brand>

                <Nav className="">
                  <Nav.Link
                    as={Link}
                    to="/"
                    active={activeItem === "home"}
                    onClick={() => updateActiveItem("home")}
                  >
                    <span>Home</span>
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    active={activeItem === "about-us"}
                    onClick={() => updateActiveItem("about-us")}
                  >
                    <span>About Us</span>
                  </Nav.Link>

                  {/* <NavDropdown
                    active={activeItem === "product"}
                    onClick={() => updateActiveItem("product")}
                    title={
                      <span>
                        {" "}
                        Product <FontAwesomeIcon icon={faChevronDown} />{" "}
                      </span>
                    }
                    id="navbarScrollingDropdown"

                  >
                    <div class="scroller">
                      <div className="row">
                        {data &&
                          data?.map((item) => (
                            <div className="col-xxl-2 col-xl-2 col-lg-3  col-md-4 mb-4  ">
                              <NavDropdown.Item className="drop-main-heading">
                                <Link to="/cctv-system">
                                  <span className="red-borders">
                                    {" "}
                                    {item.name}
                                  </span>
                                </Link>
                              </NavDropdown.Item>

                              <NavDropdown.Item className="inner-link">
                                <p className="content-name ">
                                  <Link to="/cctv-innerpage">
                                    {" "}
                                    IR Dome Camera{" "}
                                  </Link>
                                </p>{" "}
                              </NavDropdown.Item>
                              <p className="content-name">
                                IR Cube Network Camera
                              </p>
                              <p className="content-name">IR Camera</p>
                              <p className="content-name">IR Bullet Camera</p>
                              <p className="content-name">
                                IR speed Dome Camera
                              </p>
                              <div class="vl"></div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </NavDropdown> */}

                  <NavDropdown
                    active={activeItem === "product"}
                    onClick={() => updateActiveItem("product")}
                    title={
                      <span>
                        Product <FontAwesomeIcon icon={faChevronDown} />
                      </span>
                    }
                    className="productMainDrop"
                    id="navbarScrollingDropdown"
                  >
                    <div class="scroller">
                      <div className="row">
                        {data &&
                          data?.map((item, index) => (
                            <>
                              <div
                                className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 mb-4 product-vertical-line"
                                key={item.id}
                              >
                                <div>
                                  <NavDropdown.Item className="drop-main-heading">
                                    <div className="red-borders">
                                      <Link
                                        to={`cctv-system/${item.id}`}
                                        className="nav-link"
                                      >
                                        {item.name}
                                      </Link>
                                    </div>
                                  </NavDropdown.Item>
                                  {item?.subcategories?.map((subcate) => (
                                    <NavDropdown.Item
                                      className="inner-link"
                                      key={subcate.id}
                                    >
                                      <p className="content-name">
                                        <Link
                                          to={`/cctv-innerpage/${subcate?.id}`}
                                        >
                                          {subcate.name}
                                        </Link>
                                      </p>
                                    </NavDropdown.Item>
                                  ))}
                                </div>
                              </div>

                              {++index % 6 == 0 ? (
                                <>
                                  {" "}
                                  <hr />
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ))}
                      </div>
                    </div>
                  </NavDropdown>

                  {/* <Link
                    className="nav-link"
                    as={Link}
                    to="/application"
                    active={activeItem === "application"}
                    onClick={() => updateActiveItem("application")}
                  >
                    <span>Application</span>
                  </Link>

                  <Link
                    className="nav-link"
                    as={Link}
                    to="/our-client"
                    active={activeItem === "our-client"}
                    onClick={() => updateActiveItem("our-client")}
                  >
                    <span>Our Clients</span>
                  </Link>

                  <Link
                    className="nav-link"
                    as={Link}
                    to="/director-profile"
                    active={activeItem === "director-profile"}
                    onClick={() => updateActiveItem("director-profile")}
                  >
                    <span>Director's Profile</span>
                  </Link> */}
                  <Nav.Link
                    as={Link}
                    to="/application"
                    active={activeItem === "application"}
                    onClick={() => updateActiveItem("application")}
                  >
                    <span>Application</span>
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/our-client"
                    active={activeItem === "our-client"}
                    onClick={() => updateActiveItem("our-client")}
                  >
                    <span>Our Clients</span>
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/director-profile"
                    active={activeItem === "director-profile"}
                    onClick={() => updateActiveItem("director-profile")}
                  >
                    <span>Director's Profile</span>
                  </Nav.Link>

                  <Link to="/contact-us">
                    <button className="contact-btnn btn">Contact Us</button>
                  </Link>
                </Nav>

                <Link>
                  <FontAwesomeIcon
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                    onClick={handleShow}
                    icon="fa-solid fa-bars"
                  />
                </Link>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>

        <div
          class="offcanvas menu-off-canva offcanvas-end"
          tabIndex="-1"
          id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel"
        >
          <div class="offcanvas-body">
            <div className="row me-0 ms-0">
              <div className="col-md-7 p-0">
                <div className="sec-1"></div>
              </div>
              <div className="col-md-1 p-0">
                <div className="sec-2"></div>
              </div>
              <div className="col-md-4 p-0 ">
                <div className="sec-3">
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="extra-menus-div">
                    <Nav.Link
                      className="off-nav-mennn"
                      as={Link}
                      to="/complaint"
                      active={activeItem === "complaint"}
                      onClick={() => updateActiveItem("complaint")}
                    >
                      <span data-bs-dismiss="offcanvas" aria-label="Close">
                        Complaint
                      </span>
                    </Nav.Link>

                    <Nav.Link
                      className="off-nav-mennn"
                      as={Link}
                      to="/news-details"
                      active={
                        activeItem === "news-details" ||
                        activeItem === "details"
                      }
                      onClick={() => updateActiveItem("news-details")}
                    >
                      <span data-bs-dismiss="offcanvas" aria-label="Close">
                        News & Events
                      </span>
                    </Nav.Link>

                    <Nav.Link
                      className="off-nav-mennn"
                      as={Link}
                      to="/support"
                      active={activeItem === "support"}
                      onClick={() => updateActiveItem("support")}
                    >
                      <span data-bs-dismiss="offcanvas" aria-label="Close">
                        Support
                      </span>
                    </Nav.Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* mobile-view-header-start */}
      <section className="mobile-view-header">
        <div className="container-fluid">
          <div className="header_menu_holder_row">
            {/* <div className="col-2"> */}

            <div className=" my-3  ">
              <button
                className="btn menuBtn"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasmobileapp"
                aria-controls="offcanvasExample"
              >
                <FontAwesomeIcon icon="fa-solid fa-bars" />
              </button>

              <img
                className="headlogo"
                src={process.env.PUBLIC_URL + "/assets/images/logo/Logo.png"}
                alt="Logo"
              />
            </div>
            {/* </div> */}
            {/* <div className="col-10 "> */}
            <div className="contact-button my-3 text-end">
              <Link to="/contact-us">
                {" "}
                <button className="btn contact-btnn ">Contact Us</button>{" "}
              </Link>
            </div>
            {/* </div> */}
          </div>
        </div>
      </section>

      {/* mobile-offcanvas-start  */}
      <div className="mobile-app-offcanvas">
        <div
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="offcanvasmobileapp"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="offcanvas-header">
            <div as={Link} to="/">
              <img
                className="headlogo"
                src={process.env.PUBLIC_URL + "/assets/images/logo/Logo.png"}
                alt="Logo"
              />
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="all-pages">
              <Link to="/">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>Home</p>
                  </div>
                </div>
              </Link>

              <Link to="/about-us">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>About Us</p>
                  </div>
                </div>
              </Link>

              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Product</Accordion.Header>
                  <Accordion.Body>
                    {data &&
                      data?.map((item, index) => (
                        <>
                          <Accordion>
                            <Accordion.Item
                              eventKey={item?.id}
                              className="drop-main-heading"
                            >
                              <Link to={`cctv-system/${item?.id}`}>
                                {" "}
                                <Accordion.Header>
                                  <span
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                  >
                                    {item?.name}
                                  </span>
                                </Accordion.Header>{" "}
                              </Link>
                              {item?.subcategories?.map((subcate) => (
                                <Accordion.Body>
                                  <Link to={`/cctv-innerpage/${subcate?.id}`}>
                                    <p
                                      className="content-name "
                                      data-bs-dismiss="offcanvas"
                                      aria-label="Close"
                                    >
                                      {subcate.name}
                                    </p>
                                  </Link>
                                </Accordion.Body>
                              ))}
                            </Accordion.Item>
                          </Accordion>
                        </>
                      ))}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Link to="/application">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>Application</p>
                  </div>
                </div>
              </Link>

              <Link to="/our-client">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>Our Clients</p>
                  </div>
                </div>
              </Link>

              <Link to="/complaint">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>Complaint</p>
                  </div>
                </div>
              </Link>

              <Link to="/news-details">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>News & Events</p>
                  </div>
                </div>
              </Link>

              <Link to="/director-profile">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>Director's Profile</p>
                  </div>
                </div>
              </Link>

              <Link to="/support">
                <div
                  className=""
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <div className="page-holder ">
                    <p>Support</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
